import { render, staticRenderFns } from "./Computation.vue?vue&type=template&id=1d9251a4&scoped=true&"
import script from "./Computation.vue?vue&type=script&lang=js&"
export * from "./Computation.vue?vue&type=script&lang=js&"
import style0 from "./Computation.vue?vue&type=style&index=0&id=1d9251a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9251a4",
  null
  
)

export default component.exports